import { csv, csvParse } from "d3";
import { isArray, isString } from "lodash";
import axios from "axios";
class Data {

	constructor () {
		this.songs = {};
		this.artists = {};
		this.countries = {};
    
		this.pays = require("../utils/dictionnaire_pays.json");
		/* Requête SPARQL
		PREFIX banq: <http://example.org/>
		PREFIX rdaa: <http://rdaregistry.info/Elements/a/>
		PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
		SELECT distinct ?id ?country_activity ?country_birth ?role ?birth_year ?name ?label WHERE {
			OPTIONAL { ?id banq:hasActivityCountry ?country_activity . }
			OPTIONAL { ?id banq:hasBirthCountry ?country_birth . }
			OPTIONAL { ?id rdaa:P50121 ?birth_year . }
			OPTIONAL { ?performed_song banq:hasPerformer ?id . } 
			?id banq:hasName ?name .
			?id rdfs:label ?label .
			BIND("autority" as ?data_type) .
			BIND(IF(BOUND(?performed_song),"Interprète","Auteur") as ?role)
		} 
		*/

		this.artist_query = "https://data.banq.qc.ca/repositories/frerejacques?name=artist+query&infer=true&sameAs=true&query=PREFIX+banq%3A+%3Chttp%3A%2F%2Fexample.org%2F%3E%0APREFIX+rdaa%3A+%3Chttp%3A%2F%2Frdaregistry.info%2FElements%2Fa%2F%3E%0APREFIX+rdfs%3A+%3Chttp%3A%2F%2Fwww.w3.org%2F2000%2F01%2Frdf-schema%23%3E%0ASELECT+distinct+%3Fid+%3Fcountry_activity+%3Fcountry_birth+%3Frole+%3Fbirth_year+%3Fname+%3Flabel+WHERE+%7B%0A++++OPTIONAL+%7B+%3Fid+banq%3AhasActivityCountry+%3Fcountry_activity+.+%7D%0A++++OPTIONAL+%7B+%3Fid+banq%3AhasBirthCountry+%3Fcountry_birth+.+%7D%0A++++OPTIONAL+%7B+%3Fid+rdaa%3AP50121+%3Fbirth_year+.+%7D%0A++++OPTIONAL+%7B+%3Fperformed_song+banq%3AhasPerformer+%3Fid+.+%7D+%0A++++%3Fid+banq%3AhasName+%3Fname+.%0A++++%3Fid+rdfs%3Alabel+%3Flabel+.%0A++++BIND(%22autority%22+as+%3Fdata_type)+.%0A++++BIND(IF(BOUND(%3Fperformed_song)%2C%22Interpr%C3%A8te%22%2C%22Auteur%22)+as+%3Frole)%0A%7D+";
		/*
		PREFIX rdau: <http://rdaregistry.info/Elements/u/>
		PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
		PREFIX banq: <http://example.org/>
		SELECT distinct ?id ?data_type ?note ?title ?label ?parent_id ?has_parent ?country_origin ?year  (CONCAT(?composer_ids, ";", ?author_ids, ";", ?interpret_ids) as ?artist_ids)  (group_concat(distinct (?author); separator=";") as ?author_ids)  (group_concat(distinct (?performer); separator=";") as ?interpret_ids)  (group_concat(distinct (?composer); separator=";") as ?composer_ids)  WHERE {
			?id rdau:P60369 ?title .
			?id rdfs:label ?label .
			OPTIONAL { ?id banq:parentID ?parent_id. }
    		OPTIONAL { ?id rdau:P60056 ?note . }
			OPTIONAL { ?id rdau:P60073 ?year . }
			OPTIONAL { ?id rdau:P60523 ?country_origin } .
			OPTIONAL { ?id banq:hasAuthor ?author . }
    		OPTIONAL { ?id banq:hasComposer ?composer . }
    		OPTIONAL { ?id banq:hasPerformer ?performer . }
			BIND(BOUND(?parent_id) as ?has_parent) .
    		BIND("song" as ?data_type) .
		
		} GROUP BY ?id ?data_type ?note ?title ?label ?parent_id ?has_parent ?country_origin ?year ?data_type 
		*/
		this.song_query ="https://data.banq.qc.ca/repositories/frerejacques?name=&infer=true&sameAs=true&query=PREFIX+rdau%3A+%3Chttp%3A%2F%2Frdaregistry.info%2FElements%2Fu%2F%3E%0A%09%09PREFIX+rdfs%3A+%3Chttp%3A%2F%2Fwww.w3.org%2F2000%2F01%2Frdf-schema%23%3E%0A%09%09PREFIX+banq%3A+%3Chttp%3A%2F%2Fexample.org%2F%3E%0A%09%09SELECT+distinct+%3Fid+%3Fdata_type+%3Fnote+%3Ftitle+%3Flabel+%3Fparent_id+%3Fhas_parent+%3Fcountry_origin+%3Fyear++(CONCAT(%3Fcomposer_ids%2C+%22%3B%22%2C+%3Fauthor_ids%2C+%22%3B%22%2C+%3Finterpret_ids)+as+%3Fartist_ids)++(group_concat(distinct+(%3Fauthor)%3B+separator%3D%22%3B%22)+as+%3Fauthor_ids)++(group_concat(distinct+(%3Fperformer)%3B+separator%3D%22%3B%22)+as+%3Finterpret_ids)++(group_concat(distinct+(%3Fcomposer)%3B+separator%3D%22%3B%22)+as+%3Fcomposer_ids)++WHERE+%7B%0A%09%09%09%3Fid+rdau%3AP60369+%3Ftitle+.%0A%09%09%09%3Fid+rdfs%3Alabel+%3Flabel+.%0A%09%09%09OPTIONAL+%7B+%3Fid+banq%3AparentID+%3Fparent_id.+%7D%0A++++%09%09OPTIONAL+%7B+%3Fid+rdau%3AP60056+%3Fnote+.+%7D%0A%09%09%09OPTIONAL+%7B+%3Fid+rdau%3AP60073+%3Fyear+.+%7D%0A%09%09%09OPTIONAL+%7B+%3Fid+rdau%3AP60523+%3Fcountry_origin+%7D+.%0A%09%09%09OPTIONAL+%7B+%3Fid+banq%3AhasAuthor+%3Fauthor+.+%7D%0A++++%09%09OPTIONAL+%7B+%3Fid+banq%3AhasComposer+%3Fcomposer+.+%7D%0A++++%09%09OPTIONAL+%7B+%3Fid+banq%3AhasPerformer+%3Fperformer+.+%7D%0A%09%09%09BIND(BOUND(%3Fparent_id)+as+%3Fhas_parent)+.%0A++++%09%09BIND(%22song%22+as+%3Fdata_type)+.%0A%09%09%0A%09%09%7D+GROUP+BY+%3Fid+%3Fdata_type+%3Fnote+%3Ftitle+%3Flabel+%3Fparent_id+%3Fhas_parent+%3Fcountry_origin+%3Fyear+%3Fdata_type+";
	}

	async fetchData () {

		await csv("/data/songs.csv", (data) => {
			this.songs[data.id] = this.fromCSV(data);
		});
		await csv("/data/artists.csv", (data) => {
			this.artists[data.id] = this.fromCSV(data);
		});
    
		this.parse();

		return {
			songs: this.songs,
			artists: this.artists,
			countries: this.countries
		};
	}
  
	async fetchDataRemote () {
		let artist_data = await axios.get(this.artist_query, {
			transformResponse: undefined,
			headers: {"Accept": "text/csv"}
		});
		artist_data = artist_data.data
			.replace(new RegExp("http://example.org/([a-c][0]+)", "g"), "")
			.replace(new RegExp("http://example.org/([a-c])", "g"), "");
	  
		
		for (var key in this.pays) {
			artist_data = artist_data.replace(new RegExp(key, "g"), this.pays[key]);
		}	

		csvParse(artist_data, (csv_data) => {
			csv_data["data_type"] = "autority";
			this.artists[csv_data.id] = this.fromCSV(csv_data);
		});
		
		let song_data = await axios.get(this.song_query, {
			transformResponse: undefined,
			headers: {"Accept": "text/csv"}
		});

		song_data = song_data.data
			.replace(new RegExp("http://example.org/([a-c][0]+)", "g"), "")
			.replace(new RegExp("http://example.org/([a-c])", "g"), "")
			.replace(new RegExp("dbp:", "g"), "");
	  
		for (var key in this.pays) {
			song_data = song_data.replace(new RegExp(key, "g"), this.pays[key]);
		}	
		
		csvParse(song_data, (csv_data) => {
			let song = this.fromCSV(csv_data);
			song["data_type"] = "song";
			song["artist_id"] = song.artist_ids[0];
			song["composer_id"] = song.composer_ids[0];
			song["interpret_id"] = song.interpret_ids[0];
			song["author_id"] = song.author_ids[0];
			song["country_origin"] = this.mode(song.artist_ids.map(id => {
				return this.artists[id].country_activity;
			}));
			this.songs[song.id] = song;
		});
    
		this.parse();
    
		return {
			songs: this.songs,
			artists: this.artists,
			countries: this.countries
		};
	}

	setArtist (data) {
		let id = data["Id_Autorite"];

		if (this.artists[id] === undefined) { 
			this.artists[id] = {
				id: id,
				country_activity: this.getFirstValue(data["Lieux_Activites_Autorite"]).trim(),
				country_birth: this.getFirstValue(data["Lieux_Naissances_Autorite"]).trim(),
				role: this.getFirstValue(data["Relation_Chanson_Autorite"]).trim(),
				birth_year: this.getFirstValue(data["Date_Naissance_Autorite"]).trim(),
				data_type: "autority",
				name: data["Forme_Retenue_Autorite"].split(",").splice(0,2).reverse().join(" ").trim(),
				label: data["Forme_Retenue_Autorite"].split(",").splice(0,2).reverse().join(" ").trim(),
			};
		}
	}

	setSong (data) {
		let id = data["Id_Chanson"];
        
		if (this.songs[id] === undefined) { 
			this.songs[id] = {
				id: data["Id_Chanson"],
				data_type: "song",
				note: data["Note_Chanson"].trim(),  
				title: data["Titre_Chanson"].trim(),
				label: data["Titre_Chanson"].trim(),
				parent_id: data["Id_Chanson_Parent"].trim(),
				has_parent: data["Id_Chanson_Parent"] != "",
				country_activity: this.getFirstValue(data["Lieux_Activites_Autorite"]).trim(),
				country_birth: this.getFirstValue(data["Lieux_Naissances_Autorite"]).trim(),
				country_origin: this.getFirstValue(data["Lieux_Activites_Autorite"]).trim(),
				countries_origin: {
					[this.getFirstValue(data["Lieux_Activites_Autorite"])] : 1
				},
				year: data["Annee_Creation_Chanson"].trim(),
				artist_id: data["Id_Autorite"].trim(),
				artist_ids: [data["Id_Autorite"].trim()],
				author_id: data["Relation_Chanson_Autorite"].includes("Auteur") ? data["Id_Autorite"].trim() : "",
				author_ids: data["Relation_Chanson_Autorite"].includes("Auteur") ? [data["Id_Autorite"].trim()] : [],
				interpret_id: data["Relation_Chanson_Autorite"].includes("Interprète") ? data["Id_Autorite"].trim() : "",
				interpret_ids: data["Relation_Chanson_Autorite"].includes("Interprète") ? [data["Id_Autorite"].trim()] : [],
				composer_id: data["Relation_Chanson_Autorite"].includes("Compositeur") ? data["Id_Autorite"].trim() : "",
				composer_ids: data["Relation_Chanson_Autorite"].includes("Compositeur") ? [data["Id_Autorite"].trim()] : []
			};
		} else {
			this.songs[id].artist_ids.push(data["Id_Autorite"].trim());
			this.songs[id].artist_id = this.mode(this.songs[id].artist_ids);

			if (data["Relation_Chanson_Autorite"].includes("Auteur")) {
				this.songs[id].author_ids.push(data["Id_Autorite"].trim());
				this.songs[id].author_id = this.mode(this.songs[id].author_ids);
			}

			if (data["Relation_Chanson_Autorite"].includes("Interprète")) {
				this.songs[id].interpret_ids.push(data["Id_Autorite"].trim());
				this.songs[id].interpret_id = this.mode(this.songs[id].interpret_ids);
			}

			if (data["Relation_Chanson_Autorite"].includes("Compositeur")) {
				this.songs[id].composer_ids.push(data["Id_Autorite"].trim());
				this.songs[id].composer_id = this.mode(this.songs[id].composer_ids);
			}
            
			if (this.getFirstValue(data["Lieux_Activites_Autorite"]) !==  "") {
				this.songs[id].countries_origin[this.getFirstValue(data["Lieux_Activites_Autorite"])] = ++this.songs[id].countries_origin[this.getFirstValue(data["Lieux_Activites_Autorite"])] || 1;
				this.songs[id].country_origin = Object.keys(this.songs[id].countries_origin).reduce((a, b) => this.songs[id].countries_origin[a] > this.songs[id].countries_origin[b] ? a : b);
			}
		}
	}

	fromCSV (data) {
		let arrayKeys = ["artist_ids", "author_ids", "interpret_ids", "composer_ids"];
		Object.keys(data).forEach(key => {
			if (arrayKeys.includes(key)) {
				data[key] = data[key] == "" ? [] : data[key].split(";").filter(id => id != "");
			}
		});
		return data;
	}

	getFirstValue(value) {
		return value.split(";")[0];
	}

	mode (arr) {
		var numMapping = {};
		var greatestFreq = 0;
		var mode;
		arr.filter(item => item != "").forEach(function findMode(item) {
			numMapping[item] = (numMapping[item] || 0) + 1;
    
			if (greatestFreq < numMapping[item]) {
				greatestFreq = numMapping[item];
				mode = item;
			}
		});
		return mode;
	}
  
	parse () {
		this.translate();
		this.findNumberOfChildren();
		this.getCountries();
	}
  
	getCountries () {
		Object.values(this.artists).forEach(artist => {
			if (this.countries[artist.country_birth] === undefined) {
				this.countries[artist.country_birth] = {
					count: 0,
					name: artist.country_birth 
				};
			}
			this.countries[artist.country_birth].count++;
		});
	}

	translate () {
		Object.keys(this.artists).forEach(id => {
			this.artists[id].label = this.artists[id].label.replace("Groupe musical", "Musical group");
			this.artists[id].name = this.artists[id].name.replace("Groupe musical", "Musical group");
      
			let countries = ["country_activity", "country_birth"];
			countries.forEach(c => {
				this.artists[id][c] = this.translateCountry(this.artists[id][c]);
			});
		});
    
		Object.keys(this.songs).forEach(id => {
			let countries = ["country_activity", "country_birth", "country_origin"];
			countries.forEach(c => {
				this.songs[id][c] = this.translateCountry(this.songs[id][c]);
			});

		});
	}
  
	translateCountry (country) {
		if (country == "République tchèque") {
			return "Czechia";
		}
		if (country == "États-Unis") {
			return "United States";
		}
		if (country == "Belgique") {
			return "Belgium";
		}
		if (country == "Égypte") {
			return "Egypt";
		}
		if (country == "Royaume-Uni") {
			return "United Kingdom";
		}
		if (country == "Allemagne") {
			return "Germany";
		}
		if (country == "Suisse") {
			return "Switzerland";
		}
		if (country == "Italie") {
			return "Italy";
		}
		if (country == "Suède") {
			return "Sweden";
		}
		if (country == "Brésil") {
			return "Brasil";
		}
		if (country == "Mexique") {
			return "Mexico";
		}
		if (country == "Pologne") {
			return "Poland";
		}
		if (country == "Norvège") {
			return "Norway";
		}
		if (country == "Israël") {
			return "Israel";
		}
		if (country == "Argentine") {
			return "Argentina";
		}
		if (country == "Colombie") {
			return "Colombia";
		}
		if (country == "Japon") {
			return "Japan";
		}
		if (country == "Jamaïque") {
			return "Jamaica";
		}
		if (country == "Finlande") {
			return "Finland";
		}
		if (country == "Espagne") {
			return "Spain";
		}
		if (country == "Autriche") {
			return "Austria";
		}
		if (country == "Grèce") {
			return "Greece";
		}
		if (country == "Australie") {
			return "Australia";
		}
		if (country == "Nouvelle-Zélande") {
			return "New-Zealand";
		}
		if (country == "Syrie") {
			return "Syria";
		}
		if (country == "Maroc") {
			return "Morocco";
		}
		if (country == "Tunisie") {
			return "Tunisia";
		}
		if (country == "Pays-Bas") {
			return "Netherlands";
		}
		if (country == "Russie") {
			return "Russia";
		}
		if (country == "Trinité-et-Tobago") {
			return "Trinidad and Tobago";
		}
		if (country == "Liban") {
			return "Lebanon";
		}
		if (country == "Arménie") {
			return "Armenia";
		}
		if (country == "Luxembourg (pays)") {
			return "Luxembourg";
		}
		if (country == "Indonésie") {
			return "Indonesia";
		}
		if (country == "Serbie") {
			return "Serbia";
		}
		if (country == "Slovaquie") {
			return "Slovakia";
		}
    
		return country;
	}
  
	findNumberOfChildren () {

		Object.keys(this.songs).forEach(id => {
			if (this.songs[id].n_children === undefined) {
				this.songs[id].n_children = 0;
			}
		});
    
		Object.keys(this.songs).forEach(id => {      
			if (this.songs[id].parent_id && this.songs[this.songs[id].parent_id] !== undefined) {
				this.songs[this.songs[id].parent_id].n_children++;
			}
		});
	}
}

let data = new Data();



	
export { data };